import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Tab/sgds-tab-panel";
import { register } from "../../utils/ce-registry";

register("sgds-tab-panel", Component);

export default createComponent({
  react: React,
  tagName: "sgds-tab-panel",
  elementClass: Component,
  events: {}
});
